var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommerce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.630353 1.33715C0.99672 0.295146 2.13843 -0.252604 3.18047 0.113762L3.98419 0.396318C5.62821 0.974254 7.02456 1.46512 8.12342 2.00431C9.29841 2.58084 10.306 3.29106 11.0638 4.4C11.8157 5.50036 12.1262 6.70759 12.2694 8.03124C12.3336 8.62377 12.3674 9.2796 12.3853 10.0005H40.7532C45.2465 10.0005 49.2912 10.0005 50.4749 11.5393C51.6589 13.0782 51.1959 15.3969 50.2704 20.0343L48.9376 26.5002C48.0973 30.5772 47.6771 32.6155 46.2059 33.8144C44.7347 35.0133 42.6534 35.0133 38.4908 35.0133H24.35C16.913 35.0133 13.1946 35.0133 10.8842 32.5766C8.57383 30.1396 8.40523 27.5511 8.40523 19.707V12.7693C8.40523 10.7961 8.4025 9.47556 8.29275 8.46169C8.18787 7.49277 8.002 7.009 7.76132 6.65676C7.52649 6.31314 7.17005 5.992 6.36145 5.59526C5.50056 5.17284 4.33058 4.75805 2.55032 4.13214L1.85377 3.88724C0.811736 3.5209 0.264013 2.37919 0.630353 1.33715Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0723 41.9999C17.2814 41.9999 19.0723 43.7908 19.0723 45.9998C19.0723 48.2088 17.2814 49.9997 15.0723 49.9997C12.8632 49.9997 11.0724 48.2088 11.0724 45.9998C11.0724 43.7908 12.8632 41.9999 15.0723 41.9999Z",
    fill: "#6C84F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0719 42.0001C41.2809 42.0001 43.0718 43.7908 43.0718 46.0001C43.0718 48.2091 41.2809 50 39.0719 50C36.8629 50 35.072 48.2091 35.072 46.0001C35.072 43.7908 36.8629 42.0001 39.0719 42.0001Z",
    fill: "#6C84F8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommerce);
export default __webpack_public_path__ + "static/media/commerce.a097a18fbfe0e640b4f3d4d67d06a06d.svg";
export { ForwardRef as ReactComponent };